@if (useFastIconType) {
    <vn-menu-item
        [item]="item"
        [section]="MenuSection.Menu"
        [displayMode]="MenuDisplayMode.FastIcon"
        badgePosition="FastIcon"
        linkClass="am-side-item"
        iconClass="ui-icon"
        textClass="side-item-txt"
        [processClick]="false"
        (onClick)="click($event, item)" />
} @else {
    <vn-menu-item
        [item]="item"
        [section]="MenuSection.Menu"
        [displayMode]="MenuDisplayMode.Icon"
        badgePosition="afterText"
        linkClass="am-side-item"
        iconClass="ui-icon"
        textClass="side-item-txt"
        [processClick]="false"
        (onClick)="click($event, item)" />
}
